import { modelHelperModule } from './model-helper';

export const userFeedbackModelModule = angular
  .module('Q.models.user-feedback', [modelHelperModule])
  .factory('UserFeedback', function (ModelHelper, DS, $q) {
    const UserFeedback = ModelHelper.defineResource({
      name: 'UserFeedback',
      endpoint: 'user_feedbacks',
      computed: {
        teamMember: {
          get() {
            return DS.get('TeamMember', this.userId);
          },
        },
        candidate: {
          get() {
            return DS.get('Candidate', this.userId);
          },
        },
      },
      staticMethods: {
        findExisting({
          feedbackType,
          featureName,
          challenge,
          solution,
          assessment,
          assessmentResult,
        }) {
          const where = { feedbackType, featureName };
          if (solution && solution.id) {
            where.solutionId = solution.id;
          } else if (challenge && challenge.id) {
            // only reviewing a challenge, no solution
            where.challengeId = challenge.id;
            where.solutionId = null;
          }
          if (assessmentResult && assessmentResult.id) {
            where.assessmentResultId = assessmentResult.id;
          } else if (assessment && assessment.id) {
            // only reviewing an assessment without an assessment result
            where.assessmentId = assessment.id;
            where.assessmentResultId = null;
          }
          if (Object.values(where).some((v) => v !== undefined)) {
            return UserFeedback.findAll(
              {
                where,
                orderBy: 'createdAt DESC',
                per: 1,
              },
              {
                bypassCache: true,
                cacheResult: false,
              },
            )
              .then((items) => {
                return items[0];
              })
              .catch(() => null);
          } else {
            return $q.when(null);
          }
        },
      },
      methods: {},
      relations: {
        hasOne: {
          AssessmentResult: {
            localField: 'assessmentResult',
            localKey: 'assessmentResultId',
          },
          Assessment: {
            localField: 'assessment',
            localKey: 'assessmentId',
          },
          Challenge: {
            localField: 'challenge',
            localKey: 'challengeId',
          },
          Solution: {
            localField: 'solution',
            localKey: 'solutionId',
          },
        },
      },
    });

    return UserFeedback;
  });
